<!--
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 *
-->

<template>
  <div class="login">
    <div class="login-body login">
      <div class="logo-box">
        <img src="../assets/images/logo.png" alt="" class="logo" />
      </div>
      <div class="name">雅丽洁支付</div>
      <div class="tips">
        为了您账户安全，以及更好用户体验，请授权微信登录
      </div>
      <div class="butView">
        <div class="registerBut float-ani" @click="getAuthCode">授权登录</div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, ref, toRefs, onMounted } from 'vue'
import { mapGetters,useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { Toast } from 'vant'
import { urlencode, getRouteQuery, redirectTo } from "@/utils/index";
var toast1;
export default {
  setup() {
    const store = useStore()
    const router = useRouter();
    const state = reactive({
      appId: 'wx5c94c64220b09460',  //公众号appId
      code: '',
    })
    onMounted(async () => {
      let code = getRouteQuery().code;
      // 3.如果有code，则已经授权
      if (code) {
        state.code = code;
        mpLogin();   //继续下一步获取openid
      } else {
        // 1.记录上一个页面的地址
        const { redirect } = getRouteQuery()
        if (redirect) {
          store.dispatch('setLandPage', redirect);
        }
        // // 2.跳转授权
        // var url_code = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + state.appId + "&redirect_uri=" + urlencode(url) + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
        // window.location.replace(url_code);//打开这个链接，你的url后面就会跟上code的参数 
      }
    })

    //授权登录
    const getAuthCode = () => {
      toast1 = Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      let url = window.location.href;
      
      state.code = getRouteQuery().code;
      if (state.code) {
        mpLogin();   //继续下一步获取openid
      } else {
        var url_code = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + state.appId + "&redirect_uri=" + urlencode(url) + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
        window.location.replace(url_code);//打开这个链接，你的url后面就会跟上code的参数 
      }     
    }

    //登录，获取token
    const mpLogin = () => {
      const para = {
        'code': state.code
      }
      store.dispatch('LoginMp', para).then(res => {
        if(toast1){
          toast1.clear();
        }
        if (res.code === 200) {
          //查询是否注册
          fnQueryUserIsBind();
        } else {
          replaceLogin();
          // Toast(res.msg || '系统未知错误，请重试');
        }
        // return false
      }).catch(() => {
        if(toast1){
          toast1.clear();
        }
        replaceLogin();
      })
    }

   //授权失败清除当前页面code 允许重新授权注册
    const replaceLogin=()=>{
       if(state.code){
          router.push({
              path: '/login',
              replace: true
          });
        }
    }

    //查询是否注册
    const fnQueryUserIsBind = () => {
      store.dispatch('QueryUserIsBind').then(res => {
        if(res.code == 401||res.code === 403){
          //重新登录
          getAuthCode();
        }else{      
          // 需要刷新页面，否则 axios.js 文件里的 token 不会被重置
          // window.location.href = '/'
          Toast.success('授权登录成功');
          setTimeout(function(){
            // 支付人不用注册，授权登录后返回支付。
            if (store.getters['enrollState'] == 0 && store.getters.landPageRoute.indexOf('/orderpay')==-1) {
              router.replace({
                path: '/register',
                replace: true
              }); 
              return
            }else{
              router.push({
                path: store.getters.landPageRoute || '/',
                replace: true
              }); 
            }


            
          },1000)  
        }
      }).catch((err) => {
          //重新登录
          getAuthCode();        
      })
    }

    return {
      ...toRefs(state),
      getAuthCode
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../assets/style/mixin';
  .login {
    .login-body{
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .logo-box{
      width: 95px;
      height: 95px;
      border-radius: 95px;
      overflow: hidden;
      margin: 49px auto 10px;
      
      .logo {
        width: 95px;
        height: 95px;
        display: block;
      }
    }
    .name{
      font-size: 17px;
      font-weight: bold;
      margin-bottom: 24px;
      color: #FA3473;
      font-size: 24px;
    }
    .tips{
      font-size: 12px;
      font-weight: 400;
      color: #999999;
    }
    .butView{
      position: fixed;
      bottom: 100px;
      left: 0;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .registerBut{
        font-size: 15px;
        margin-bottom: 16px;
        letter-spacing: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 89.3%;
        height: 44px;
        margin-top: 60px;
        background: #FA3474;
        border-radius: 40px;
        color: #fff;
      }
    }
  }
</style>
